export const TX_NOTIFICATION_TYPES = {
  STANDARD_TX: 'STANDARD_TX',
  CONFIRMATION_TX: 'CONFIRMATION_TX',
  CANCELLATION_TX: 'CANCELLATION_TX',
  WAITING_TX: 'WAITING_TX',
  SETTINGS_CHANGE_TX: 'SETTINGS_CHANGE_TX',
  NEW_SPENDING_LIMIT_TX: 'NEW_SPENDING_LIMIT_TX',
  REMOVE_SPENDING_LIMIT_TX: 'REMOVE_SPENDING_LIMIT_TX',
  SAFE_NAME_CHANGE_TX: 'SAFE_NAME_CHANGE_TX',
  OWNER_NAME_CHANGE_TX: 'OWNER_NAME_CHANGE_TX',
  ADDRESSBOOK_NEW_ENTRY: 'ADDRESSBOOK_NEW_ENTRY',
  ADDRESSBOOK_EDIT_ENTRY: 'ADDRESSBOOK_EDIT_ENTRY',
  ADDRESSBOOK_DELETE_ENTRY: 'ADDRESSBOOK_DELETE_ENTRY',
}
